import { DialogBody, DialogHeader } from '@spotify/confidence-core-react';

import { ChildChatTranscriptView } from '../ChatThread/ChildChatTranscriptView';

import classes from './CodingSessions.module.css';

export const CodingSessionDialog = ({
  childChatName,
  title,
  onClose,
}: {
  childChatName: string;
  title: string;
  onClose: () => void;
}) => (
  <>
    <DialogHeader title={title} onClose={onClose} />
    <DialogBody autoHeight>
      <ChildChatTranscriptView
        childChatName={childChatName}
        className={classes.transcript}
      />
    </DialogBody>
  </>
);
